import { render } from "./HeroiconsSolidMinusCircle.vue?vue&type=template&id=bae6c64e"
const script = {}

import exportComponent from "/home/harlan/sites/kintell-env/api/packages/nova/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"HeroiconsSolidMinusCircle.vue"]])

export default __exports__